module.exports = __webpack_public_path__ + "static/bluedoubleknit-80562eb732f3d7603de64e183758a7f3.jpeg";